<span
  [ixTest]="[title, rowTestId(row), 'row-schedule']"
>{{ value | scheduleToCrontab }}</span>
